module.exports = __webpack_public_path__ + "img/my_qrcode_facebook.41b19b3.png";